// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-input-group__append,.el-input-group__prepend{background-color:#1890ff !important;color:#fff !important;border-color:#1890ff !important;border-radius:0 4px 4px 0}.block{text-align:right;padding-bottom:20px}", ""]);
// Exports
module.exports = exports;
